import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {firstValueFrom, Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {
  getActionPointGallery,
  getActionPointList,
  getAPListByMetric,
  getFeeds,
  getGlobalStatistics,
  getMomentsGallery,
  getSearch,
  isNewPost
} from '../variables';

import {GlobalService} from '../global/global.service';
import {ApiResponse, handleError} from '../utils';
import {AuthService} from '../auth/auth.service';
import {CompanyModel} from "../../models/company.model";
import {UserModel} from "../../models/user.model";
import {CompanyService} from "../company/company.service";

@Injectable({
  providedIn: 'root'
})
export class FeedService {

  constructor(public globalService: GlobalService,
              public auth: AuthService,
              public companyService: CompanyService,
              public http: HttpClient) {
  }

  apiGetFeeds(page): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(getFeeds + '?page=' + page, {headers: this.auth.jsonheader}).pipe(
      catchError(handleError)
    );
  }

  getActionPointList(page, type): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(getActionPointList + '/' + type + '?page=' + page, {headers: this.auth.jsonheader}).pipe(
      catchError(handleError)
    );
  }

  apiGlobalStatistics(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(getGlobalStatistics, {headers: this.auth.jsonheader}).pipe(
      catchError(handleError)
    );
  }

  apiHomeSearch(type, query, page): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(getSearch + '/' + type + '/' + query + '?page=' + page, {headers: this.auth.jsonheader}).pipe(
      catchError(handleError)
    );
  }

  apiIsNewPost(id): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(isNewPost + '/' + id, {headers: this.auth.jsonheader}).pipe(
      catchError(handleError)
    );
  }

  apiGetAPListByMetric(id, page): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(getAPListByMetric + '/' + id + '?page=' + page, {headers: this.auth.jsonheader}).pipe(
      catchError(handleError)
    );
  }

  apiGetMomentsGallery(momentId: string | null, page: number = 1, actionPointId?: string): Observable<ApiResponse> {
    const momentIdForUrl = momentId ? momentId : 'null';
    let url = `${getMomentsGallery}/${momentIdForUrl}`;

    if (actionPointId) {
      url += `/${actionPointId}`;
    }

    url += `?page=${page}`;

    return this.http.get<ApiResponse>(url, {
      headers: this.auth.jsonheader
    }).pipe(
      catchError(handleError)
    );
  }

  apiGetPageForMoment(momentId: string, actionPointId: string): Observable<ApiResponse> {
    const url = `${getMomentsGallery}/${momentId}/${actionPointId}`;

    return this.http.get<ApiResponse>(url, {
      headers: this.auth.jsonheader
    }).pipe(
      catchError(handleError)
    );
  }

  apiGetActionPointFeedGallery(momentId?: string, actionPointId?: string, page: number = 1): Observable<ApiResponse> {
    let url = `${getActionPointGallery}`;

    if (momentId !== undefined) {
      url += `/${momentId}`;
      if (actionPointId !== undefined) {
        url += `/${actionPointId}`;
      }
    }

    url += `?page=${page}`;

    return this.http.get<ApiResponse>(url, {
      headers: this.auth.jsonheader
    }).pipe(
      catchError(handleError)
    );
  }

  async followCompany(company: CompanyModel, user: UserModel): Promise<boolean> {
    if (user && this.auth.isAuthenticated) {
      const result = await firstValueFrom(
        this.companyService.apiFollowCompany(company.id)
      );

      if (result.status) {
        await this.globalService.presentToast(result.message);
        return true;
      }
      return false;
    }
    return false;
  }

  async unfollowCompany(company: CompanyModel): Promise<boolean> {
    const result = await firstValueFrom(this.companyService.apiUnfollowCompany(company.id));

    if (result.status) {
      await this.globalService.presentToast(result.message);
      return true;
    }

    return false;
  }

}
